// The terms shown in the Submission Confirmation popup. Accepting them is stored on the project
// (`submissionTermsAcceptance`) with a copy of the exact clauses, so a later change here doesn't rewrite what an
// earlier applicant agreed to. The CMS stamps `acceptedAt` with the server time.

export const SUBMISSION_TERMS_LEAD = "By clicking “Confirm”"

export const SUBMISSION_TERMS = [
  `${SUBMISSION_TERMS_LEAD}, you agree that all information provided for your project is accurate and complete, including location, construction details, and applicant information. You understand that incorrect or incomplete information may lead to an inaccurate assessment and potential damage to our services, for which you will be responsible.`,
  "You also accept that any damage to our services related to this project will be at your cost, regardless of our assessment outcome, including if the project is marked as “not affected”.",
  "If the scope of work changes, or if there is any deviation from the route, location, or area of work specified in the original application, a new application must be submitted reflecting the revised scope, route, location, or area of work.",
  "Any existing approval applies only to the details provided in the approved application and does not authorise any changes or deviations. No revised or additional works may proceed until a new application has been submitted and the necessary approval has been granted.",
]

export type SubmissionTermsAcceptance = {
  accepted: boolean
  acceptedAt?: string
  acceptedBy?: {
    id?: Maybe<string>
    fullName?: Maybe<string>
    email?: Maybe<string>
  }
  terms: string[]
}

type AcceptingProfile = Maybe<{
  id?: Maybe<string>
  attributes?: Maybe<{ fullName?: Maybe<string>; primaryEmail?: Maybe<string> }>
}>

export const buildSubmissionTermsAcceptance = (profile: AcceptingProfile): SubmissionTermsAcceptance => ({
  accepted: true,
  acceptedBy: {
    id: profile?.id,
    fullName: profile?.attributes?.fullName,
    email: profile?.attributes?.primaryEmail,
  },
  terms: SUBMISSION_TERMS,
})

export const parseSubmissionTermsAcceptance = (value: unknown): SubmissionTermsAcceptance | null => {
  if (!value || typeof value !== "object") return null
  const acceptance = value as Partial<SubmissionTermsAcceptance>
  if (!acceptance.accepted) return null
  return { ...acceptance, accepted: true, terms: Array.isArray(acceptance.terms) ? acceptance.terms : [] }
}
